function convertNumbers2English(number: string) {
  return number
    ?.replace(/[\u0660-\u0669]/g, function (c: string) {
      return String(c.charCodeAt(0) - 0x0660);
    })
    ?.replace(/[\u06f0-\u06f9]/g, function (c) {
      return String(c.charCodeAt(0) - 0x06f0);
    });
}
export default convertNumbers2English;
